export function arrayFindNext<T>(arr: T[] | readonly T[], current: T): T {
  const next = arr.includes(current) ? arr[(arr.indexOf(current) + 1) % arr.length] : arr[0]
  return next
}
